import { decodeHtmlEntities } from '../utils/decodeHtmlEntities';

const TAG = /<\/?[a-z][^>]*>/i;

/**
 * A stored note body as text to show or edit.
 *
 * The field is named html, and it held HTML until the editor became a textarea: a body written or
 * seeded before then is paragraphs in tags, which shown as typed reads "<p>Home visit.</p>". Since
 * then the api stores plain text, entity-escaped, which is decoded once here. A body with tags is
 * read as the paragraphs it holds, one line each, so both kinds read as the text somebody wrote.
 */
export const noteBodyText = (html: string): string => {
    if (!TAG.test(html)) {
        return decodeHtmlEntities(html);
    }
    const withBreaks = html
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/(p|div|li|h[1-6]|blockquote)>/gi, '\n')
        .replace(/<[^>]+>/g, '');
    return decodeHtmlEntities(withBreaks).replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
};
